<template>
  <LandingpageCard
    :name="campaign.name"
    has-action
  >
    <template v-slot:action>
      <Download
        outlined
        :count="readyMaterials.length"
        :path="`/materials/campaign/${campaign.id}`"
        :filename="`Materialien_${campaign.name}`"
      />
    </template>
    <template v-slot:content>
      <v-row>
        <template v-for="material in readyMaterials">
          <v-col
            v-for="{ file, previewFile } in material.files"
            :key="file.id || file.url || file.cdnUrl"
            :cols="12"
            :sm="4"
            :md="3"
          >
            <MaterialCard
              :name="material.displayName"
              :url="file.cdnUrl"
              :thumbnail-url="previewFile && previewFile.cdnUrl"
              :icon="material.icon"
              @download="$tracking.event('Landingpages', 'Clicked', 'Download Template')"
            />
          </v-col>
        </template>
      </v-row>
    </template>
  </LandingpageCard>
</template>

<script>
import MaterialStaticPreview from '@/assets/img/material-static-preview.svg'
import MaterialVideoPreview from '@/assets/img/material-video-preview.svg'
import { isPdfFile } from '@/modules/adMaterials/fileTypes'

import Download from '../Download.vue'
import LandingpageCard from '../LandingpageCard.vue'
import MaterialCard from '../MaterialCard'

const ICONS = {
  STATIC: MaterialStaticPreview,
  GENERATED: MaterialVideoPreview,
}

export default {
  components: { MaterialCard, Download, LandingpageCard },
  props: {
    campaign: { type: Object, required: true },
    materials: { type: Array, required: true },
    country: { type: String, required: true },
  },
  computed: {
    readyMaterials() {
      return this.materials
        .filter(({ hasFile }) => hasFile)
        .map((material) => {
          const files = (material.files || []).filter((materialFile) => materialFile?.file?.cdnUrl)
          const hasPreviewFile = files.some(
            ({ previewFile }) => previewFile?.cdnUrl && !isPdfFile(previewFile.cdnUrl)
          )

          return {
            ...material,
            files,
            ...(!hasPreviewFile && { icon: ICONS[material.mode] }),
          }
        })
        .filter(({ files }) => files.length > 0)
    },
  },
}
</script>
